<template>
  <div>
    <bs-page-title
      :titleLabel="fromParentTitle"
      :btnLabel="fromParentBtn"
      :btnClass="'btn-primary'"
    ></bs-page-title>
    <bs-msg-alert :alertClass="alertClass">{{
      this.alertMessage
    }}</bs-msg-alert>
    <div class="w100">
      <div class="row mb-3">
        <div class="col-4">
          <label for="Label" class="form-label">名称</label>
          <input
            type="text"
            class="form-control"
            id="Label"
            placeholder="名称"
            v-model="license_event_cd.label"
          />
        </div>
        <div class="col-2">
          <label for="LicenseEventCd" class="form-label">コード</label>
          <input
            type="text"
            class="form-control"
            id="LicenseEventCd"
            placeholder="コード"
            v-model="license_event_cd.license_event_cd"
          />
        </div>
        <div class="col-4">
          <label for="ShortLabel" class="form-label">略称</label>
          <input
            type="text"
            class="form-control"
            id="ShortLabel"
            placeholder="略称"
            v-model="license_event_cd.short_label"
          />
        </div>
        <div class="col-2">
          <label for="Sort" class="form-label">sort</label>
          <input
            type="number"
            class="form-control"
            id="Sort"
            placeholder="ソート"
            v-model="license_event_cd.sort"
          />
        </div>
      </div>
      <div class="mb-5"></div>
      <div class="row mb-3">
        <div class="col-12 col-sm-4 mb-2">
          <button
            type="submit"
            @click="back"
            class="btn btn-light btn-outline-secondary"
          >
            戻る
          </button>
        </div>
        <div class="col-12 col-sm-4 mb-2 text-center">
          <button type="submit" @click="update" class="btn btn-primary">
            {{ btnLabel }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BsPageTitle from '../../molecules/BsPageTitle.vue'
import BsMsgAlert from '../../atoms/BsMsgAlert.vue'
// import BsCheckBox from '../../atoms/BsCheckBox.vue'
import config from '../../../const'

export default {
  name: 'LicenseEventCdDetailView',
  data: function () {
    return {
      targetid: this.$route.params.id,
      fromParentTitle: '昇降格データ',
      fromParentBtn: '',
      alertMessage: '',
      alertClass: 'alert-info',
      btnLabel: '',
      license_event_cd: {}
    }
  },
  components: {
    BsPageTitle,
    // BsSelect,
    BsMsgAlert
    // BsButton,
    // BsCheckBox,
  },
  methods: {
    async loadLicenseEventCdObj() {
      const params = {}
      params['id'] = this.targetid
      await this.basicPosts_S(
        config.BASE_API_URL + '/license_event_cd/lists',
        params
      )
        .then(async response => {
          console.log('loadLicenseEventCdObj', response)
          this.license_event_cd =
            response.data && response.data.body && response.data.body[0]
              ? response.data.body[0]
              : {}
        })
        .catch(async err => {
          console.log(err)
          this.license_event_cd = {}
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    update() {
      console.log('component methods', this.license_event_cd)
      return this.$store
        .dispatch('updateBasic', {
          data: this.license_event_cd,
          target: 'license_event_cd'
        })
        .then(() => {
          this.alertMessage = this.btnLabel + 'しました'
          this.alertClass = 'alert-success'
        })
        .catch(err => {
          Promise.reject(err)
          this.alertMessage = this.btnLabel + 'できませんでした'
          this.alertClass = 'alert-danger'
        })
        .finally(async () => {
          await this.loadEventCdObj()
        })
    },
    back() {
      this.$router.go(-1)
    }
  },
  computed: {
    ...mapState({})
  },

  async created() {
    if (Number.isNaN(this.targetid)) {
      this.$router.push({ path: '/' })
    } else if (this.targetid != 'add' && !Number.isNaN(this.targetid)) {
      this.loadLicenseEventCdObj()
      this.btnLabel = '更新'
    } else {
      this.license_event_cd_obj = {
        id: 0,
        label: '',
        license_event_cd: '',
        sort: 0
      }
      this.btnLabel = '登録'
    }
    this.alertMessage = this.btnLabel + 'できます'
  },
  mounted: function () {
    this.fromParentTitle = '昇降格データ'
    // console.log('tags_list', this.tags_list);
  },
  props: {}
}
</script>
